// eslint-disable-next-line import/prefer-default-export
export const AVAILABILITY_AB_TEST_MARKETS = [
  'SAN_JOSE_CA',
  'RICHMOND_VA',
  'JACKSONVILLE_FL',
  'MINNEAPOLIS_MN',
  'CINCINNATI_OH',
  'LOS_ANGELES_CA',
  'BOSTON_MA',
  'PORTLAND_OR',
  'MIAMI_FL',
  'MEMPHIS_TN',
  'LOUISVILLE_KY',
  'TUCSON_AZ',
  'COLORADO_SPRINGS_CO',
  'OMAHA_NE',
];
